import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { FormBuilder, Validators } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { OfframpService } from '../../services/offramp.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

const defaults = {
  notif: {
    timeOut: 3000,
    showProgressBar: true,
    pauseOnHover: false,
    clickToClose: true,
    maxLength: 50
  }
};

@Component({
  selector: 'app-add-offramp-exchange-quote',
  templateUrl: './add-offramp-exchange-quote.component.html',
  styleUrls: ['./add-offramp-exchange-quote.component.css']
})
export class AddOfframpExchangeQuoteDialog implements OnInit {
  element: any = {};
  myForm: any;
  liquidityProviderList: any[] = [];
  isEditMode: boolean = false;
  recordId: string = '';
  currentUserDisplay: string = '';

  constructor(
    public dialogRef: MatDialogRef<AddOfframpExchangeQuoteDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notifSer: NotificationsService,
    public fb: FormBuilder,
    public userService: UserService,
    public offrampService: OfframpService,
    private spinnerService: Ng4LoadingSpinnerService
  ) {
    this.element = data.record || {};
    this.isEditMode = !!this.element._id;
    this.recordId = this.element._id || '';

    const loggedInUser = this.userService.getUserDetails();
    this.currentUserDisplay = loggedInUser ? `${loggedInUser.name} (${loggedInUser.email})` : '';

    this.myForm = this.fb.group({
      adminid: [
        this.element.adminid ? (this.element.adminid._id || this.element.adminid) : (loggedInUser ? loggedInUser._id : ''),
        [Validators.required]
      ],
      liquidity_provider_id: [
        this.element.liquidity_provider_id ? (this.element.liquidity_provider_id._id || this.element.liquidity_provider_id) : ''
      ],
      from_currency: [this.element.from_currency || '', [Validators.required]],
      to_currency: [this.element.to_currency || '', [Validators.required]],
      rate: [this.element.rate || 0, [Validators.required, Validators.min(0)]],
      status: [this.element.status || 'New', [Validators.required]],
      communication_status: [this.element.communication_status || 'New', [Validators.required]],
    });
  }

  ngOnInit() {
    this.loadLiquidityProviderList();
  }

  loadLiquidityProviderList() {
    const filter = { _csrf: this.data._csrf, limit: 10000, page: 1 };
    this.offrampService.getAllOfframpExchanges(filter).subscribe(
      (response: any) => {
        this.liquidityProviderList = (response && response.data) || [];
      },
      () => {
        this.notifSer.error('Error', 'Failed to load liquidity provider list', defaults.notif);
        this.liquidityProviderList = [];
      }
    );
  }

  saveQuote() {
    const { notif } = defaults;

    if (this.myForm.invalid) {
      this.notifSer.error('Error', 'Please fill all required fields', notif);
      return;
    }

    this.spinnerService.show();

    const formData: any = {
      ...this.myForm.value,
      _csrf: this.data._csrf
    };

    if (this.isEditMode) {
      formData._id = this.recordId;
      this.offrampService.updateOfframpExchangeQuote(formData).subscribe(
        (response) => {
          this.spinnerService.hide();
          if (response.status || response.success) {
            this.notifSer.success('Success', response.message || 'Quote updated successfully', notif);
            this.dialogRef.close({ success: true, data: response });
          } else {
            this.notifSer.error('Error', response.message || 'Failed to update quote', notif);
          }
        },
        (err) => {
          this.spinnerService.hide();
          this.notifSer.error('Error', (err.error && err.error.message) || 'Failed to update quote', notif);
        }
      );
    } else {
      this.offrampService.createOfframpExchangeQuote(formData).subscribe(
        (response) => {
          this.spinnerService.hide();
          if (response.status || response.success) {
            this.notifSer.success('Success', response.message || 'Quote created successfully', notif);
            this.dialogRef.close({ success: true, data: response });
          } else {
            this.notifSer.error('Error', response.message || 'Failed to create quote', notif);
          }
        },
        (err) => {
          this.spinnerService.hide();
          this.notifSer.error('Error', (err.error && err.error.message) || 'Failed to create quote', notif);
        }
      );
    }
  }

  onCancel() {
    this.dialogRef.close({ success: false });
  }
}



// WEBPACK FOOTER //
// ./src/app/offramp-exchange-quotes/add-offramp-exchange-quote/add-offramp-exchange-quote.component.ts